import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { GpAsteriskService } from './services/gp-asterisk.service';
import { GpAsteriskState } from './states/gp-asterisk/gp-asterisk.state';
import { GP_ASTERISK_CONFIG_TOKEN, GpAsteriskConfigModel } from './symbols';

@NgModule({
  imports: [
    NgxsModule.forFeature([GpAsteriskState])
  ]
})
export class GpAsteriskModule {
  static forRoot(config?: GpAsteriskConfigModel): ModuleWithProviders<GpAsteriskModule> {
    return {
      ngModule: GpAsteriskModule,
      providers: [
        {
          provide: GP_ASTERISK_CONFIG_TOKEN,
          useValue: { ...config }
        }
      ]
    };
  }
}
